import { i18n } from 'plugins/i18n.js'
import moment from 'moment'
import elasticApi from '@/api/elasticApi'
import ApplicationApi from '@/api/applicationApi'
import Vue from 'vue'
const api = new ApplicationApi()
const elastic_api = new elasticApi()

import { eventBus } from '@/main'

export default {
  methods: {
    async filterApps(filter_type, update_count) {
      let items = this.applications.slice(0)
      if (this.loading && Vue.prototype.$last_controller) {
        Vue.prototype.$last_controller.abort()
        this.$log('abort')
        Vue.prototype.$last_controller = undefined
      }
      this.loading = true

      if (!filter_type) {
        window.scrollTo({ top: 0, behavior: 'smooth' })
      }
      this.filtred_count = 0

      let push = !filter_type,
        bar_type = this.filters.from_bar,
        setConditionObject = filter => ({
          type: filter?.type,
          contains: filter?.contain,
          search: filter?.search
        }),
        search = {
          appType: bar_type || 'ALL',
          conditions: null,
          query: this.filters.search.trim(),
          take: this.per_page,
          skip: 0
        },
        new_apps

      if (this.filters.from_menu?.filters?.length) {

        search.conditions = {
          andOperator: this.filters.from_menu.mode,
          conditions: this.filters?.from_menu?.filters?.map(setConditionObject)
        }
      }

      if (update_count || !Object.keys(this.app_count).length) {
        await this.updateCount(search.query, search.conditions)
      }

      if (!this.app_count[bar_type]?.count) {
        items = []
      } else if (!push || this.count < this.app_count[bar_type]?.count || update_count) {
        if (!push) {
          this.count = 0
          this.$refs.infinity_updater?.updateScrollCount(true)
          this.$set(this, 'groups', {})
          this.$set(this, 'filtredItems', [])
          items = []
        }
        try {
          search.skip = this.count
          await elastic_api.applicationElastic(search)
            .then(async res => {
              new_apps = res
              push ? items.push(...res) : items = res
              if (res?.length) {
                this.count += res.length
              }
              items = this.$_.uniqBy(items, 'id')
            })
            .finally(() => {
              eventBus.$emit('finishLoadingContent', ['setPurchaseSettings'])
            })
        } catch (error) {
          this.$log_error(error.message)
          this.loading = false
          return
        }
      }

      if (new_apps?.length) {
        this.fillCreators(new_apps)
        if (this.filters.from_bar != 'DRAFT' && !this.$can('have', 'AgreementsProcess')) {
          this.fillAcceptors(new_apps)
        }
      }

      if (new_apps?.length || items.length <= this.app_count[bar_type]?.count) {
        this.groupByDate(Object.keys(this.groups).length ? new_apps : items, this.filters?.from_menu?.filters?.filter(el => el.type == 'Period'), push)
      }

      this.filtred_count = this.app_count[bar_type]?.count
      this.applications = items
      this.loading = false
      if (this.startProp) {
        setTimeout(() => {
          this.setOldScrollPosition()
        }, 500)
      }
      return items
    },
    async updateCount(text, conditions) {
      await api.getApplicationCounts(text, conditions).then(res => this.app_count = this.$_.keyBy(res, 'type'))
    },
    groupByDate(apps, byDates) {
      let week = new moment(moment().format('w'), 'w').toDate()
      let currMonth = new moment(moment().format('M'), 'M').toDate()
      let pastMonth = new moment(moment().format('M'), 'M').subtract(1, 'months').toDate()
      let pastYear = new moment(moment().format('Y'), 'Y').subtract(1, 'year').toDate()
      let currYear = new moment(moment().format('Y'), 'Y').toDate()

      const getFirstDate = (date) => {
        return moment(date).subtract(1, 'day').toDate()
      }

      const getObject = (date, labelText, labelDate) => {
        return {
          label: labelText && labelDate ?
            labelText + ' ' + i18n.d(date, 'shortDate') + ' - ' + i18n.d(getFirstDate(labelDate), 'shortDate') :
            null,
          date,
          dateStr: i18n.d(date, 'shortDate')
        }
      }

      let today = getObject(new Date(), null, null)
      let todayName = getObject(today.date, this.$t('Purchasing.Today'), new Date())
      let weekName = getObject(week, this.$t('Purchasing.ThisWeek'), today.date)
      let currMonthName = getObject(currMonth, this.$t('Purchasing.ThisMonth'), week)
      let pastMonthName = getObject(pastMonth, this.$t('Purchasing.PastMonth'), currMonth)
      let yearName = getObject(currYear, this.$t('Purchasing.ThisYear'), pastMonth)
      let pastYearName = getObject(pastYear, this.$t('Purchasing.PastYear'), currYear)

      let groups = {}

      groups[todayName.label] = []
      groups[weekName.label] = groups[weekName] || []
      groups[currMonthName.label] = []
      groups[pastMonthName.label] = []
      groups[yearName.label] = []
      groups[pastYearName.label] = []
      groups['Purchasing.Earlier'] = []
      if (byDates?.length) {
        byDates.map(filter => {
          let name = this.getText(...filter.search)
          groups[name] = []
          apps = this.$_.filter(apps, item => {
            let date = new Date(item.creationDate)
            if (date >= filter[0] && date <= filter[1]) {
              groups[name].push(item)
            } else {
              return true
            }
          })
        })
      }
      if (apps?.length) {
        apps
          .forEach(item => {
            if (!item) { return }
            let date = new Date(item.creationDate)
            if (date == today) {
              groups[todayName.label].push(item)
            } else if (date >= week) {
              groups[weekName.label].push(item)
            } else if (date >= currMonth) {
              groups[currMonthName.label].push(item)
            } else if (date >= pastMonth) {
              groups[pastMonthName.label].push(item)
            } else if (date >= currYear) {
              groups[yearName.label].push(item)
            } else if (date >= pastYear) {
              groups[pastYearName.label].push(item)
            } else {
              groups['Purchasing.Earlier'].push(item)
            }
          })
      }
      let last_groups = {}
      Object.entries(groups).forEach(([key, items]) => {
        if (this.groups[key]) {
          let its = this.groups[key].slice(0)
          its.push(...items)
          last_groups[key] = its
        } else {
          last_groups[key] = items
        }
      })

      this.groups = last_groups
    },
    formatAppDateTo(item) {
      let result = '–'
      if (!item) {
        return result
      }
      let named_date = type => type == 'U' ? this.$t('Purchasing.Urgently') : this.$t('Catalog.NotImportantDate'),
        date_to = date => {
          if (date.includes('highlight') || (!moment(date, 'DD.MM.YYYY').isValid() && !moment(date).isValid())) {
            return date || this.$t('Catalog.NotImportantDate')
          }
          const year = this.$i18n.locale === 'en' ? '' : ' ' + this.$t('Common.Year')

          return this.$t('Common.DateTo') + ' ' +
      (moment(date, 'DD.MM.YYYY').isValid() ? moment(date, 'DD.MM.YYYY').format('DD MMMM YYYY') : moment(date).format('DD MMMM YYYY'))
      + year
        }

      if (typeof item == 'string') {
        if (item == 'U' || item == 'H') {
          result = named_date(item)
        } else {
          result = date_to(item)
        }
      } else {
        if (item.approvedPriority?.id || item.dateTypeId) {
          result = named_date(item.dateTypeId || item.approvedPriority.id)
        } else {
          let typed = item.approvedSupplyDate || item.deliveryTerms
          if (typed) {
            result = date_to(typed)
          }
        }
      }

      return result
    },
    getDate(items) {
      if (!items) { return this.$t('Common.NoData') }
      if (this.$_.find(items, el => el.children)) {
        let children = []
        items.forEach(item => item.children ? children.push(...item.children) : children.push(item))
        items = children
        let condition = (el) => el.approvedSupplyDate && typeof el.approvedSupplyDate == 'object'
        if (this.$_.some(items, el => condition(el))) {
          items = this.$_.map(items, el => {
            if (condition(el)) {
              return el.approvedSupplyDate
            } else {
              return el
            }
          })
        }
      }

      let important = this.$_.find(items, el => el.approvedPriority?.id == 'U')
      if (important) {
        return important
      }
      let last_date = moment(Math.min(...items.map(el => Date.parse(el.approvedSupplyDate)).filter(el => el)))

      let res = last_date.isValid()
        ? last_date.format()
        : (
          this.$_.find(items, el => el.approvedPriority?.id == 'H') ||
          {
            approvedPriority: {
              name: this.$t('Catalog.NotImportantDate'),
              id: 'H'
            }
          }
        )
      return res
    },
    getSum(items, isGroup) {
      let result
      if (isGroup) {
        result = items?.reduce((total, el) => {
          return total + parseFloat(this.getSum(el.children).replace(/[^\d]/g, ''))
        }, 0)
      } else {
        result = items?.reduce((total, el) => {
          return total + parseFloat(el.summa || this.sum(el) || 0)
        }, 0)
      }
      // result = (result + '').replace(/(\d)(?=(\d\d\d)+([^\d]|$))/g, '$1 ')
      return result + ''
    },
    sum(item, check) {
      let quantity = item.quantity || item.approvedQuantity || item.declaredQuantity,
        summa = item.price && quantity ? item.price * (check ? item.declaredQuantity : quantity) : ''
      // if (check) {
      //  this.fieldsChange ? this.fieldsChange() : this.$emit('fieldsChange')
      // }
      return summa ? +summa.toFixed(2) : ''
    },
    findComments(items = []) {
      let comments = []
      items.forEach((el) => {
        if (el.comments && el.comments.length > 0) {
          el.comments.forEach(elem => {
            elem.resourceName = elem.resourceName ? elem.resourceName : el.resource.fullName
            comments.push(elem)
          })
        }
      })
      return comments
    },
    getCurrencyName(item, summ, short) {
      if (!summ) {
        summ = 0
      }
      let result
      if (short) {
        return item?.currency?.name || '–'
      }
      let strsumm = summ.toString()
      let last = strsumm.substring(strsumm.length - 1)
      if (item && item.currency) {
        if (last == 1) {
          result = item.currency.nominativeName
        } else if (last >= 2 && last <= 4) {
          result = item.currency.genitiveName
        } else {
          result = item.currency.genitivePluralName
        }
      }
      return result || item?.currency?.name || item?.currency?.symbol ||  '–'
    }
  }
}
